export const guides = [
  {
    id: "identify-fake-investment",
    title: "三分钟识别假投资平台：看这五个地方就够了",
    category: "金融防骗",
    summary:
      "不用懂金融也能快速判断一个投资平台是否可疑。把资质、收款方式、收益承诺、提现规则和拉新机制这五项过一遍，大多数资金盘会当场露馅。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20of%20a%20magnifying%20glass%20over%20blurred%20financial%20documents%20on%20warm%20beige%20paper%2C%20deep%20vermillion%20and%20ochre%20accents%2C%20soft%20directional%20light%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=guide-one-01&orientation=landscape",
    coverAlt: "放大镜覆盖在虚化财务文件上的抽象图，象征识别假投资平台",
    date: "2026-08-20",
    readMinutes: 5,
    steps: [
      {
        heading: "第一看：资质主体是否对得上",
        paragraphs: [
          "把 App 或网站里展示的机构名称、备案编号记下来，通过官方渠道核对。如果名称对不上、编号查不到，或者主体频繁变更，风险等级直接拉满。",
          "注意区分「展示的牌照」和「实际运营的公司」。很多平台会借用其他机构的资质图片，这本身就已经是危险信号。"
        ]
      },
      {
        heading: "第二看：钱进了谁的口袋",
        paragraphs: [
          "正规投资渠道的资金流向是清晰且可追溯的。如果要求你把钱转到个人账户、陌生公司账户，或者通过购买虚拟商品的方式充值，请直接停止。",
          "同样需要警惕的是「充值容易、提现困难」。提现需要拉人、需要完成任务、需要缴纳解冻金，都是资金盘的典型特征。"
        ]
      },
      {
        heading: "第三看：收益承诺与拉新机制",
        paragraphs: [
          "任何承诺固定高收益、保本保息的投资都是违规的。收益越稳定、越高，越不可能是真实投资。",
          "如果平台的奖励高度依赖发展下线，收益结构呈现明显的层级关系，那它更接近传销而非投资，风险极高。"
        ]
      }
    ]
  },
  {
    id: "refund-call-script",
    title: "接到陌生退款电话，照着这四步做就不会出错",
    category: "网络防骗",
    summary:
      "假客服的核心目标只有一个：拿到你的验证码或让你转账。只要坚持不透露验证码、不脱离官方渠道，这类骗局几乎无法得手。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20of%20a%20smartphone%20lying%20face%20down%20beside%20a%20paper%20checklist%20on%20warm%20cream%20paper%2C%20deep%20red%20rim%20light%2C%20ochre%20accents%2C%20moody%20shadows%2C%20no%20text%2C%20cinematic&width=1200&height=800&seq=guide-two-02&orientation=landscape",
    coverAlt: "手机背面朝下放在纸质清单旁的抽象图，象征应对假客服退款电话",
    date: "2026-08-06",
    readMinutes: 4,
    steps: [
      {
        heading: "第一步：先挂断，不解释",
        paragraphs: [
          "对方越催你，越说明他怕你有时间思考。直接挂断，不需要告知理由，也不要在电话里透露任何信息。",
          "挂断后不要回拨对方提供的号码，那可能是他们自己设置的转接线路。"
        ]
      },
      {
        heading: "第二步：用官方 App 反向核实",
        paragraphs: [
          "自己打开购物或支付 App，在订单详情页找到官方客服入口发起咨询。真正需要退款时，平台会通过站内渠道与你联系。",
          "记住一个铁律：退款永远原路返回，不需要你提供验证码，也不需要你先把钱转到任何账户。"
        ]
      }
    ]
  },
  {
    id: "prepaid-5-checks",
    title: "办预付卡之前，一定要查的 5 件事",
    category: "消费维权",
    summary:
      "预付卡的风险大多可以在办卡前识别。花十分钟核对经营主体、租期、促销力度、员工稳定性和退费条款，能避免大部分跑路损失。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20a%20membership%20card%20and%20a%20folded%20receipt%20on%20warm%20beige%20paper%20surface%2C%20ochre%20and%20deep%20red%20accents%2C%20soft%20studio%20shadow%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=guide-three-03&orientation=landscape",
    coverAlt: "会员卡与折叠收据放在米色纸面上的静物，象征预付卡消费核查",
    date: "2026-07-22",
    readMinutes: 5,
    steps: [
      {
        heading: "查主体与租期",
        paragraphs: [
          "核对营业执照上的名称与实际招牌是否一致，并了解门店租期还剩多久。租期临近却在大力度促销的门店，需要格外小心。",
          "如果同一品牌在短时间内频繁更换主体名称，通常意味着经营状况不稳定。"
        ]
      },
      {
        heading: "看促销与退费条款",
        paragraphs: [
          "折扣力度明显超出同行时，先想想商家为什么急着让你一次付清。同时确认合同中是否写明退费方式、计算标准和办理时限。",
          "口头承诺一律要求写入合同，签字前完整拍照留存。"
        ]
      }
    ]
  },
  {
    id: "second-hand-checklist",
    title: "二手交易避坑清单：每一笔都该这样做",
    category: "消费维权",
    summary:
      "二手交易的风险集中在交易方式、验货环节和证据留存三处。把交易留在平台内、收件即验、全程留痕，风险会下降一大截。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20of%20cardboard%20packaging%20tape%20and%20a%20pair%20of%20scissors%20on%20warm%20beige%20table%2C%20deep%20vermillion%20and%20ochre%20tones%2C%20soft%20shadow%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=guide-four-04&orientation=landscape",
    coverAlt: "纸箱打包胶带与剪刀放在米色桌面上的抽象图，象征二手交易验货",
    date: "2026-07-08",
    readMinutes: 4,
    steps: [
      {
        heading: "交易全程留在平台内",
        paragraphs: [
          "拒绝任何形式的私下转账、扫码付款和脱离平台的定金。平台内交易才有订单记录和申诉通道，这是你唯一的保障。",
          "对方向你强调「私下更便宜」时，基本可以判断交易存在风险。"
        ]
      },
      {
        heading: "收件即验，全程留痕",
        paragraphs: [
          "尽量当面签收并录像开箱，重点拍清快递单号、包装完整度和商品细节。发现问题不要急于确认收货。",
          "保留完整的聊天记录与商品描述截图，一旦发生纠纷，这些都是关键证据。"
        ]
      }
    ]
  },
  {
    id: "family-firewall",
    title: "帮家里长辈装一道防骗防火墙",
    category: "家庭防骗",
    summary:
      "长辈受骗往往不是不懂，而是缺少可以商量的人。与其反复说教，不如建立几个简单的约定和检查习惯，让风险在发生前被拦住。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20warm%20abstract%20of%20two%20tea%20cups%20and%20a%20small%20potted%20plant%20on%20beige%20table%20by%20a%20window%2C%20soft%20afternoon%20light%2C%20ochre%20and%20deep%20red%20accents%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=guide-five-05&orientation=landscape",
    coverAlt: "窗边米色桌上两只茶杯与一盆绿植的温暖抽象画面，象征家庭防骗沟通",
    date: "2026-06-25",
    readMinutes: 5,
    steps: [
      {
        heading: "先建立商量的习惯",
        paragraphs: [
          "和长辈约定：只要涉及金额较大的转账或购买，先给家人打个电话。重点是把这条约定说成一种关心，而不是不信任。",
          "日常多聊身边发生的骗局案例，比出事之后指责有效得多。"
        ]
      },
      {
        heading: "做几项具体的设置",
        paragraphs: [
          "帮长辈关闭不必要的免密支付，设置转账限额，并把可疑号码标记功能打开。这些设置能在关键时刻争取到冷静时间。",
          "在手机里存好官方客服电话与报警电话，方便长辈第一时间核实。"
        ]
      }
    ]
  },
  {
    id: "golden-30-minutes",
    title: "被骗后的黄金 30 分钟：按顺序做这几件事",
    category: "应急处置",
    summary:
      "发现被骗后，时间就是止损效率。保留证据、立即报警、联系银行与平台，顺序和速度都会直接影响能否追回资金。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20of%20a%20clock%20face%20reflected%20on%20warm%20beige%20paper%20beside%20a%20pen%2C%20deep%20vermillion%20and%20ochre%20accents%2C%20dramatic%20soft%20shadow%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=guide-six-06&orientation=landscape",
    coverAlt: "时钟倒影与钢笔出现在米色纸面上的抽象图，象征被骗后的应急处置",
    date: "2026-06-11",
    readMinutes: 4,
    steps: [
      {
        heading: "先固化证据，再打电话",
        paragraphs: [
          "完整截图聊天记录、转账凭证、对方账号信息与平台页面，不要急着清理对话。证据一旦丢失，后续追查会困难很多。",
          "记录下转账时间、金额与收款账户，这些信息在报警时需要准确提供。"
        ]
      },
      {
        heading: "报警并同步联系银行",
        paragraphs: [
          "第一时间拨打报警电话说明情况，同时联系银行或支付平台申请紧急止付。越早发起，资金被拦截的可能性越高。",
          "之后保持通讯畅通，配合后续调查，不要轻信任何「帮忙追款」的第三方，那往往是二次诈骗。"
        ]
      }
    ]
  }
];

export const guideCategories = [
  "全部",
  "金融防骗",
  "网络防骗",
  "消费维权",
  "家庭防骗",
  "应急处置"
];